<template>
   <div class="user_profile_wrap">
        <div class="title">{{get_local_string.string_124}}</div>

      <div class="delete_accounts">
          <b-button uk-toggle="target: #modal-delete" type="is-danger"
                icon-left="delete">
                {{get_local_string.string_124}}
            </b-button>
      </div>
      <div id="modal-delete" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <h2 class="uk-modal-title">{{get_local_string.string_124}}</h2>
        <p class="mb-3">{{get_local_string.string_125}}</p>
        <p class="uk-text-right">
            <button class="uk-button uk-button-default uk-modal-close mr-2" type="button">{{get_local_string.string_126}}</button>
           <b-button :loading="loading" type="is-danger" @click.native="delete_account()"
                icon-left="delete">
                {{get_local_string.string_124}}
            </b-button>
        </p>
    </div>

   </div>
   </div>
</template>
<script>
import { mapActions , mapGetters } from 'vuex'
export default {
     name:'discount_profile',
     data(){
         return{
              loading:false,
              errorMsg:''
         }
     },
     computed:{
        ...mapGetters({
         get_local_string:'get_local_string'
    })
    },
     methods:{
         ...mapActions({
           delete_account_api:'delete_account_api',
         }),
         delete_account(){
           this.loading = true;
           this.delete_account_api().then((res)=>{
           console.log(res , 'console delete comp');
           if(res.status ==200){
             this.errorMsg =res.message;
             this.success();
             this.loading = false;
              window.location.reload();
           }
           else{
             this.errorMsg ='User Not Found !';
             this.danger();
             this.loading = false;
           }
           });
          //  this.delete_account_api((res)=>{
          //    console.log(res , 'console delete comp');
          //  })
           
         },
            success() {
          const notif = this.$buefy.notification.open({
              duration: 4000,
              message: this.errorMsg,
              position: 'is-bottom-right',
              type: 'is-success',
              hasIcon: true
          })
          notif.$on('close', () => {
              // this.$buefy.notification.open('Custom notification closed!')
          }
          )
      },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
     },
     mounted(){
       
     }
}
</script>

<style lang="scss" scoped>
.user_profile_wrap{
.title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: var(--active_color);
    border-bottom: 3px solid var(--active_color);
    padding-bottom: 6px;
    }
}




</style>
